export function hypotenuse(a, b) {
  let r = 0;
  if (Math.abs(a) > Math.abs(b)) {
    r = b / a;
    return Math.abs(a) * Math.sqrt(1 + r * r);
  }
  if (b !== 0) {
    r = a / b;
    return Math.abs(b) * Math.sqrt(1 + r * r);
  }
  return 0;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/node_modules/ml-matrix/src/dc/util.js
// module id = null
// module chunks = 